import { AntSelect } from "./styles";

export default AntSelect;
